/**
 * Chiave dell'oggetto del context che contiene i valori _da validare_.
 * Utilizzando la `VALIDATION_VALUES_KEY` in un `.when` è quindi possibile accedere
 * ai valori che si stanno validando.
 */
export const VALIDATION_VALUES = '__VALIDATION_VALUES';

/**
 * Versione della `VALIDATION_VALUES` da utilizzare come chiave nell'array delle dipendenze
 * del `.when()`. (essendo un valore di contesto, ha il "$" davanti).
 */
export const VALIDATION_VALUES_KEY = `$${VALIDATION_VALUES}`;
